// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1xUiB","productName":"Table_productName__22Zxm"};